@if (loading) {
  <div 
    class="loader-container"
    [class.full-screen]="fullScreen"
    [class.with-backdrop]="backdrop"
    [class.overlay]="overlay">
    <div class="loader-content">
      <mat-spinner 
        [diameter]="spinnerSize"
        [strokeWidth]="strokeWidth"
        class="loader-spinner">
      </mat-spinner>
      @if (message) {
        <p class="loader-message">{{ message }}</p>
      }
    </div>
  </div>
}

